import { getPanAndZoomFromLocalStorage, ProjectId } from 'owa-timestream-store';
import areBoundsOverlapped from '../util/areBoundsOverlapped';
import getAssetsBoundingRect from './getAssetsBoundingRect';
import getCanvasBounds from './getCanvasBounds';
import getDefaultPanAndZoom from './getDefaultPanAndZoom';

export default function getPersistedOrDefaultPanAndZoom(
    projectId: ProjectId,
    initialLoad?: boolean
) {
    const savedPanAndZoom = getPanAndZoomFromLocalStorage(projectId);
    if (savedPanAndZoom === null) {
        return getDefaultPanAndZoom(initialLoad);
    }

    const { width, height } = getCanvasBounds();
    const assetsBounds = getAssetsBoundingRect();
    const savedPanRect = {
        top: -savedPanAndZoom.pan.y,
        left: -savedPanAndZoom.pan.x,
        bottom: -savedPanAndZoom.pan.y + height,
        right: -savedPanAndZoom.pan.x + width,
    };
    return areBoundsOverlapped(savedPanRect, assetsBounds)
        ? savedPanAndZoom
        : getDefaultPanAndZoom();
}
